/* eslint-disable jsx-a11y/img-redundant-alt */
import { getPublicUrlPath } from '@doltech/utils/lib/location';
import cl from 'classnames';
import { noop } from 'lodash';
import * as React from 'react';
import styled from 'styled-components';

import { responsiveBreakPoints } from '../../../../../../../hooks/useDeviceQuery.hook';
import { colorsV2 } from '../../../../../../colors-v2';
import { Typography } from '../../../../../../DesignSystemV2/Typography';
import { DoTestQuizAnswerModeEnum } from '../../../types';
import { OptionShareStyles } from './OptionText';

const Main = styled.div`
  ${OptionShareStyles}
  position: relative;
  border-radius: 8px;
  padding: 8px;
  min-height: 56px;
  overflow: hidden;

  .poll-result {
    position: absolute;
    top: 8px;
    left: 8px;
    padding: 2px 8px;
    z-index: 2;
    border-radius: 4px 0;
  }
  .poll-text {
    font-size: 10px;
    font-weight: 600;
    line-height: 20px;
    color: ${colorsV2.white100};
  }

  .choice-wrapper {
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-columns: 100px minmax(0, 1fr);
    align-items: center;
    gap: 24px;

    .image-wrapper {
      user-select: none;
      width: 100px;
      height: 100px;
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
    .choice {
      display: grid;
      align-items: center;
      user-select: none;
    }
    .poll-result {
      text-align: right;
    }
    @media ${responsiveBreakPoints['above-540']} {
      grid-template-columns: 1fr;
      .image-wrapper {
        width: 100%;
      }
    }
  }

  &.${DoTestQuizAnswerModeEnum.RESULT_WRONG} {
    border: 2px solid ${colorsV2.red100};
    background-color: ${colorsV2.red10};
    .choice-wrapper {
      color: ${colorsV2.black100};
    }
    .poll-result {
      background-color: ${colorsV2.red100};
    }
  }

  &.${DoTestQuizAnswerModeEnum.RESULT_CORRECT} {
    border: 2px solid ${colorsV2.green100};
    background-color: ${colorsV2.green10};
    .choice-wrapper {
      color: ${colorsV2.black100};
    }
    .poll-result {
      background-color: ${colorsV2.green100};
    }
  }

  &.${DoTestQuizAnswerModeEnum.RESULT_DEFAULT} {
    border: 1px solid ${colorsV2.gray20};
    background-color: ${colorsV2.gray10};
    .poll-result {
      display: none;
      color: ${colorsV2.gray100};
    }
  }
`;

interface OptionImageProps {
  mode: DoTestQuizAnswerModeEnum;
  selected?: boolean;
  text: string;
  image: any;

  percentage?: number;
  onClick?: (e: any) => void;
}

export const OptionImage = (props: OptionImageProps) => {
  const { mode, selected, percentage = 0, text, image, onClick = noop } = props;
  return (
    <Main onClick={onClick} className={cl('quizz-answer-option-image', mode, { selected })}>
      <div
        onMouseDown={(e) => e.preventDefault()}
        contentEditable={false}
        className="choice-wrapper"
      >
        <div
          onMouseDown={(e) => e.preventDefault()}
          contentEditable={false}
          className="image-wrapper"
        >
          <img
            onMouseDown={(e) => e.preventDefault()}
            src={image?.url || getPublicUrlPath(image?.path)}
            alt={image?.name}
          />
        </div>
        <div contentEditable={false} onMouseDown={(e) => e.preventDefault()} className="choice">
          <Typography.Paragraph variant="regular/18" className="choice">
            {text}
          </Typography.Paragraph>
        </div>
      </div>
      <div onMouseDown={(e) => e.preventDefault()} contentEditable={false} className="poll-result">
        <div onMouseDown={(e) => e.preventDefault()} contentEditable={false} className="poll-text">
          {percentage}% chọn
        </div>
      </div>
    </Main>
  );
};
